import React from "react";
import { CanceljobonFulldetail } from "../../../../components/uih/ma_list/modal/Canceljob";
import AssginJobComponent from "../../../../components/uih/ma_list/AssignJobcomponent/AssignJobComponent";
import AckjobConfirmModalFull from "../../../../components/uih/ma_list/modal/AckjobConfirmModal";
import SubAckJobfull from "../../../../components/uih/ma_list/modal/SubAckJob";
import StoptimeModal from "../../../../components/uih/full_detail_job/stop_time/StoptimeModal";
import RejectJobModal from "../../../../components/uih/ma_list/modal/RejectJobModal";
import SmsRequsetModal from "../../../../components/uih/full_detail_job/sms_requset_modal/SmsRequestModal";
export default function RenderModalDynamic({
  CompanyId,
  OperatorId,
  ProjectId,
  workflow,
  language,
  factupdate,
  Jobdetail,
  showRejectModal,
  setshowRejectModal,
  showCancel,
  setshowCancel,
  showManageMM,
  setshowManageMM,
  showManagesub,
  setshowManagesub,
  showAssignMM,
  setshowAssignMM,
  showAssignSub,
  setshowAssignSub,
  showmmAckjob,
  setshowmmAckjob,
  showSubackjob,
  setshowSubackjob,
  showstopTime,
  setshowstopTime,
  showModalSmsOn,
  setshowModalSmsOn,
  showModalSmsOff,
  setshowModalSmsOff,
  Jobdata,
}) {
  return (
    <>
      {showRejectModal ? (
        <RejectJobModal
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          jobDetail={Jobdetail}
          workflowJob={workflow}
          Modalshow={showRejectModal}
          setModalshow={setshowRejectModal}
          so_id={Jobdetail?.so_id || Jobdata?.result_job_detail[0].so_id}
        ></RejectJobModal>
      ) : null}
      {showCancel ? (
        <CanceljobonFulldetail
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          jobDetail={Jobdetail}
          workflowJob={workflow}
          Modalshow={showCancel}
          setModalshow={setshowCancel}
          so_id={Jobdetail?.so_id || Jobdata?.result_job_detail[0].so_id}
        ></CanceljobonFulldetail>
      ) : null}
      {showManageMM ? (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showManageMM}
          setModalShow={setshowManageMM}
          workflowJob={workflow}
          jobDetail={Jobdetail}
          currentPage={2}
          title={"Manage M&M"}
          AdvanceSearch={true}
          showOldassign={true}
          showStartasAckJob={false}
          typeModal={"manage"}
          Teamgroupdutycode={"C"}
          ShowMap={true}
          EnableAssignTeam={false}
          useCookies={false}
          wrapClassName={`bbtec-theme`}
        ></AssginJobComponent>
      ) : null}
      {showManagesub ? (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showManagesub}
          setModalShow={setshowManagesub}
          workflowJob={workflow ? workflow : null}
          jobDetail={Jobdetail}
          currentPage={2}
          title={"Manage Sub"}
          typeModal={"manage"}
          AdvanceSearch={true}
          showOldassign={true}
          showStartasAckJob={true}
          Teamgroupdutycode={"O"}
          ShowMap={true}
          EnableAssignTeam={false}
          useCookies={false}
          wrapClassName={`bbtec-theme`}
        ></AssginJobComponent>
      ) : null}
      {showAssignMM ? (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showAssignMM}
          setModalShow={setshowAssignMM}
          workflowJob={workflow ? workflow : null}
          jobDetail={Jobdetail}
          currentPage={2}
          title={"Assign to MM "}
          typeModal={"assign"}
          AdvanceSearch={true}
          showOldassign={false}
          showStartasAckJob={false}
          Teamgroupdutycode={"C"}
          ShowMap={true}
          EnableAssignTeam={false}
          useCookies={false}
          wrapClassName={`bbtec-theme`}
        ></AssginJobComponent>
      ) : null}
      {showAssignSub ? (
        <AssginJobComponent
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showAssignSub}
          setModalShow={setshowAssignSub}
          workflowJob={workflow ? workflow : null}
          jobDetail={Jobdetail}
          currentPage={2}
          title={"Assign to Sub "}
          typeModal={"assign"}
          AdvanceSearch={true}
          showOldassign={false}
          showStartasAckJob={false}
          Teamgroupdutycode={"O"}
          ShowMap={true}
          EnableAssignTeam={false}
          useCookies={false}
          wrapClassName={`bbtec-theme`}
        ></AssginJobComponent>
      ) : null}
      {showmmAckjob ? (
        <AckjobConfirmModalFull
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showmmAckjob}
          setModalShow={setshowmmAckjob}
          workflowJob={workflow ? workflow : null}
          jobDetail={Jobdetail}
          currentPage={2}
          so_id={Jobdetail?.so_id || Jobdata?.result_job_detail[0].so_id}
          useCookies={false}
        ></AckjobConfirmModalFull>
      ) : null}
      {showSubackjob ? (
        <SubAckJobfull
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          ModalShow={showSubackjob}
          setModalShow={setshowSubackjob}
          workflowJob={workflow ? workflow : null}
          jobDetail={Jobdetail}
          currentPage={2}
          so_id={Jobdetail?.so_id || Jobdata?.result_job_detail[0].so_id}
          useCookies={false}
        ></SubAckJobfull>
      ) : null}
      {showstopTime ? (
        <StoptimeModal
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          modalOpen={showstopTime}
          setmodalOpen={setshowstopTime}
          language={language}
          factupdate={factupdate}
          job_id={Jobdetail?.job_id}
          job_progress_id={Jobdetail?.job_progress_id}
          job_type_id={Jobdetail?.job_type_id}
          Workflowdata={workflow}
          canEditstart={true}
          canEditend={true}
          wrapClassName={`bbtec-theme`}
        ></StoptimeModal>
      ) : null}
      {showModalSmsOn ? (
        <SmsRequsetModal
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          modalOpen={showModalSmsOn}
          setmodalOpen={setshowModalSmsOn}
          language={language}
          factupdate={factupdate}
          jobDetail={Jobdetail}
          Jobdata={Jobdata}
          mode={"onsite"}
          wrapClassName={`bbtec-theme`}
        ></SmsRequsetModal>
      ) : null}
      {showModalSmsOff ? (
        <SmsRequsetModal
          CompanyId={CompanyId}
          OperatorId={OperatorId}
          ProjectId={ProjectId}
          modalOpen={showModalSmsOff}
          setmodalOpen={setshowModalSmsOff}
          language={language}
          factupdate={factupdate}
          jobDetail={Jobdetail}
          mode={"offsite"}
          wrapClassName={`bbtec-theme`}
          Jobdata={Jobdata}
        ></SmsRequsetModal>
      ) : null}
    </>
  );
}
